import './App.css';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import React, { useState } from 'react';
import { motion } from "framer-motion";
import * as Yup from "yup";
import { Box, TextField } from '@mui/material';
import CampoDeTexto from './Utilidades/CampoDeTexto';
import './css/Gestor.css';
import { buscarTurnos, cancelarTurno } from './APIfuncs/APIposters';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Slide from '@mui/material/Slide';
import CircularProgress from '@mui/material/CircularProgress';
import CachedIcon from '@mui/icons-material/Cached';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const theme = createTheme({
  palette: {
    botonCancelar: {
      light: '#ff5970',
      main: '#ff304d',
      dark: '#b22135',
      contrastText: '#fff',
    }
    
  },
});

function GestorTurnos() {

  const [datosTurno, setDatosTurno] = useState({dni: 0, email: ""})
  const [encontroTurnos, setEncontroTurnos] = useState(false)
  const [turnosEncontrados, setTurnosEncontrados] = useState(null)
  const [loading, setLoading] = useState(false);
  const [aviso, setAviso] = useState("");
  const [open, setOpen] = useState(false);
  
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const VALORES_INICIALES = {
    dni: "",
    correo: "",
  }
    
  const FORM_VALIDATION = Yup.object().shape({
    dni: Yup.number()
        .typeError("Ingrese un DNI válido (sin espacios ni '.')")
        .required("Ingrese un DNI"),
    correo: Yup.string()
        .matches(/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/ , 'Ingrese un Email válido')
        .required("Ingrese un correo"),
  });

  return (
    <motion.div 
      className='gestor'
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.8 }} >

    <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description">

        <DialogTitle style={{"textAlign": "center"}} >{"Importante:"}</DialogTitle>
        <DialogContent sx={{px: "40px"}}>
          <DialogContentText id="alert-dialog-slide-description">
            {aviso}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Entendido</Button>
          {/* {encontroTurnos && <Button onClick={handleClose} href="/nuevaturnera/gestiones" >Entendido</Button>} */}
        </DialogActions>
      </Dialog>

      <Dialog
        open={loading}
        TransitionComponent={Transition}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent sx={{px: "20px"}}>
          <DialogContentText id="alert-dialog-slide-description" style={{display:"flex", alignItems: "center"}}>
          <CircularProgress style={{"marginRight": "40px"}} color='secondary'/> Eliminando turno... 
          </DialogContentText>
        </DialogContent>
      </Dialog>

      {!encontroTurnos && 

      <div className='gestor-form'>
        <h1 style={{"fontSize": "1.2rem", "fontWeight": "800", "margin": "1.5%"}}>Ingrese sus datos para buscar sus turnos</h1>
        <div style={{"display":"flex", "justifyContent":"center", "width": "100%"}}>
          <Formik
              initialValues={VALORES_INICIALES}
              validationSchema={FORM_VALIDATION}

              onSubmit={async(valores) =>{
                  setDatosTurno({...datosTurno, dni: valores.dni, email: valores.correo});
                  const turnosAux = await buscarTurnos(JSON.stringify({dni: valores.dni, email: valores.correo}), setLoading);
                  if (!turnosAux.status) {
                    setTurnosEncontrados(turnosAux);
                    setEncontroTurnos(true);
                  }
                  else{
                    setAviso(<div>
                      <p>
                        No se encontraron turnos para el usuario ingresado. <br/><br/>
                        Por favor, compruebe los datos.
                      </p>
                    </div>)
                    handleOpen();
                  }
              }}
          >
              <Form className='formulario' style={{"width": "90%", "maxWidth": "400px", "minWidth": "240px"}}>
                  <CampoDeTexto name="correo" label="Email" ></CampoDeTexto>
                  <CampoDeTexto name="dni" label="N° de documento" ></CampoDeTexto>
                  <div>
                      <button type='submit' style={{"minWidth": "130px", "margin": "auto"}}>Buscar turno</button>
                  </div>
              </Form>
          </Formik>
        </div>
      </div>
      }

      {encontroTurnos && turnosEncontrados && 
      <div>
        <h1 style={{"color": "#fff"}}>Turnos encontrados de {turnosEncontrados[0].nombreUser + " " + turnosEncontrados[0].apellidoUser}:</h1>
        <div className='espacio-turnos'>
          {turnosEncontrados.map(turno => 
            <>
                <div className='container-turno'>
                  <p className='label-turno'> Te esperamos en: </p>
                  <p className='contenido-turno'>{turno.nombreDelegacion}</p>
                  <hr/>
                  <p className='label-turno'> Tu turno es el: </p>
                  <p className='contenido-turno'>{turno.codigo}</p>
                  <hr/>
                  <p className='label-turno'> Para el día: </p>
                  <p className='contenido-turno'>{turno.diaCompleto}</p>
                  <hr/>
                  <p className='label-turno'> En el horario: </p>
                  <p className='contenido-turno'>{turno.hora}</p>
                  <hr/>
                  <p className='label-turno'> Domicilio: </p>
                  <p className='contenido-turno'>{turno.domicilioDelegacion}</p>
                  <hr/>
                  <p className='label-turno'> Área: </p>
                  <p className='contenido-turno'>{turno.nombreModulo}</p>
                  <hr/>
                  <p className='label-turno'> Dependencia: </p>
                  <p className='contenido-turno'>{turno.nombreDelegacion}</p>
                  <hr/>
                  <p className='label-turno'> Servicio: </p>
                  <p className='contenido-turno'>{turno.nombre}</p>
                  <hr/>
                  <br/>
                  <div className='cont-boton-cancel'>
                  <ThemeProvider theme={theme}>
                    <Button 
                        variant='contained' 
                        type='button' 
                        color='botonCancelar'
                        className='boton-gestion-turno'
                        endIcon={<CancelOutlinedIcon/>}
                        disabled={loading}
                        onClick={async() => {
                          const auxTurnoCancelado = await cancelarTurno(turno.dniUser, turno.codigo, setLoading);
                          if (auxTurnoCancelado.status == "ok") {
                            setAviso(
                            <div>
                              <p>
                                El turno fue cancelado con éxito.
                              </p>
                            </div>)
                            handleOpen();
                          }
                          else{
                            setAviso(
                              <div>
                                <p>
                                  El turno no se pudo cancelar.
                                </p>
                              </div>)
                              handleOpen();
                          }

                          const turnosAux = await buscarTurnos(JSON.stringify(datosTurno), setLoading);
                          if (!turnosAux.status) {
                            setTurnosEncontrados(turnosAux);
                          }
                          else setTurnosEncontrados(null);
                        }}> Cancelar turno</Button>
                    </ThemeProvider>
                </div>
              </div>
            </>
            )}
            <div className='cont-boton' style={{"marginTop": "15px"}}>
              <Button 
                      variant='contained' 
                      type='button' 
                      color='inherit'
                      className='boton-gestion-turno'
                      endIcon={<CachedIcon/>}
                      onClick={() => {
                        setTurnosEncontrados(null);
                        setEncontroTurnos(false);
                      }}>Nueva consulta</Button>
            </div>
        </div>
      </div>
      }

    {encontroTurnos && !turnosEncontrados && 
      <div style={{"display": "flex", "flexDirection": "column"}}>
        <h1 style={{"color": "#fff"}}>No quedan más turnos</h1>
        <div className='cont-boton' style={{"marginTop": "15px"}}>
          <Button 
                  variant='contained' 
                  type='button' 
                  color='inherit'
                  className='boton-gestion-turno'
                  endIcon={<CachedIcon/>}
                  onClick={() => {
                    setTurnosEncontrados(null);
                    setEncontroTurnos(false);
                  }}>Nueva consulta</Button>
        </div>
      </div>
    }
      
    </motion.div>
  );
}

export default GestorTurnos;
